/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

export class ApprovalRequest {


    public productId: number;
    public approvalFlag: number;

     constructor(approvalRequest: any) {
         this.productId = approvalRequest.productId || '';
         this.approvalFlag = approvalRequest.approvalFlag || '';
     }
 }
